<template>
  <div>
    <div
      v-for="(item, index) in list"
      :key="index"
      @click="showDetail(item)"
      class="list-item"
    >
      <img
        :src="require('@assets/icon_attentions.png')"
        style="width: 1.8rem;  margin-right: .5rem;"
        alt=""
      />
      <div>{{ item.title }}</div>
      <van-icon name="arrow" style="margin-right: 0;margin-left: auto;" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      content: ""
    };
  },
  created() {
    this.$http.post(this.$api.REFERENCE_ATTENTIONS_LIST).then(res => {
      this.list = res;
    });
  },
  methods: {
    showDetail(item) {
      this.$http
        .post(this.$api.REFERENCE_ATTENTIONS_DETAIL, {
          announcementsId: item.announcementsId
        })
        .then(res => {
          this.$dialog.alert({
            title: item.title,
            message: res.content
          });
        });
    }
  }
};
</script>

<style lang="less" scoped>
.list-item {
  display: flex;
  align-items: center;
  margin: 0.9rem 0;
  padding: 1rem;
  border-bottom: 1px solid #f4f4f4;
}
</style>

<style lang="less">
.van-dialog__message {
  overflow-x: hidden;
  text-align: left;
}
</style>
